import React from 'react';

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="border-b border-gray-200 overflow-x-auto overflow-y-hidden scrollbar-hide">
      {/* Mobile scrollable tabs - min-w-max prevents tabs from shrinking */}
      <nav aria-label="Tabs" className="-mb-px flex space-x-1 sm:space-x-8 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              whitespace-nowrap border-b-2 py-4 px-4 sm:px-1 text-sm font-medium flex items-center min-h-[44px]
              ${activeTab === tab.id
                ? 'border-cyan-500 text-cyan-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }
            `}
          >
            {tab.label}
            {tab.badge && tab.badge}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TabNavigation;
